import { api } from '@/api/ApiGateway.js'

class UserOrganizationsApi
{
	create(p_assigner, p_user_id, p_organization_id, p_on_success, p_on_error)
	{
		api.post('user-organizations/user-organizations', {
			'request': {
				'send_email_eh': true, //Not sent if adding org to yourself
				'app_service_eh': false,
				'assigner': p_assigner,
				'user_id': p_user_id,
				'organization_id': p_organization_id
			}
		}).then(response =>
		{
			if (response.hasError())
			{
				p_on_error(response)
				return
			}
			if (!response.body()?.data)
			{
				response.overrideError({ detail: 'Error creating user organization.' })
				p_on_error(response)
				return
			}

			p_on_success(response.body()?.data)
		})
	}

	createRoleOnly(userId, organizationRole, organizationTitle, onSuccess, onError)
	{
		api.post('user-organizations/user-organizations/role-only', {
			'user_organization': {
				'user_id': userId,
				'organization_role': organizationRole,
				'organization_title': organizationTitle
			}
		}).then(response =>
		{
			if (response.hasError())
			{
				onError(response)
				return
			}
			if (!response.body()?.data)
			{
				response.overrideError({ detail: 'Error creating user organization.' })
				onError(response)
				return
			}

			onSuccess(response.body()?.data)
		})
	}

	update(userOrganizationData, onSuccess, onError)
	{
		api.patch('user-organizations/user-organizations', userOrganizationData).then(response =>
		{
			if (response.hasError())
			{
				onError(response)
				return
			}
			if (!response.body()?.data)
			{
				response.overrideError({ detail: 'Error updating user organization.' })
				onError(response)
				return
			}

			onSuccess(response.body()?.data)
		})
	}

	delete(userOrganizationId, onSuccess, onError)
	{
		api.delete(`user-organizations/user-organizations/${userOrganizationId}`).then(response =>
		{
			if (response.hasError())
			{
				onError(response)
				return
			}
			try
			{
				onSuccess()
			}
			catch (e)
			{
				response.overrideError({ detail: `${e}` })
				onError(response)
			}
		})
	}

	permDelete(userOrganizationId, onSuccess, onError)
	{
		api.delete(`user-organizations/user-organizations/${userOrganizationId}`).then(response =>
		{
			if (response.hasError())
			{
				onError(response)
				return
			}
			try
			{
				onSuccess()
			}
			catch (e)
			{
				response.overrideError({ detail: `${e}` })
				onError(response)
			}
		})
	}

	restore(userOrganizationId, onSuccess, onError)
	{
		api.get(`user-organizations/user-organizations/restore/${userOrganizationId}`).then(response =>
		{
			if (response.hasError())
			{
				onError(response)
				return
			}
			if (!response.body()?.data)
			{
				response.overrideError({ detail: 'Error restoring user organization data.' })
				onError(response)
				return
			}

			onSuccess(response.body()?.data)
		})
	}

	getForOrganization(organizationId, onSuccess, onError)
	{
		api.get(`user-organizations/user-organizations/${organizationId}`).then(response =>
		{
			if (response.hasError())
			{
				onError(response)
				return
			}
			if (!response.body()?.data)
			{
				response.overrideError({ detail: 'Error loading user organization data.' })
				onError(response)
				return
			}

			onSuccess(response.body()?.data)
		})
	}

	getForUser(userId, onSuccess, onError)
	{
		api.get(`user-organizations/user-organizations/user/${userId}`).then(response =>
		{
			if (response.hasError())
			{
				onError(response)
				return
			}
			if (!response.body()?.data)
			{
				response.overrideError({ detail: 'Error loading user organization data.' })
				onError(response)
				return
			}

			onSuccess(response.body()?.data)
		})
	}
}

export const userOrganizationsApi = new UserOrganizationsApi()